import { render, staticRenderFns } from "./ReportArticlesItemRow.vue?vue&type=template&id=b4c38bbe&scoped=true&"
import script from "./ReportArticlesItemRow.vue?vue&type=script&lang=js&"
export * from "./ReportArticlesItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ReportArticlesItemRow.vue?vue&type=style&index=0&id=b4c38bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c38bbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})
